import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconForward = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 7,
	height: 12,
	viewBox: "0 0 7 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.45312 5.49609C6.69922 5.76953 6.69922 6.17969 6.45312 6.42578L1.20312 11.6758C0.929688 11.9492 0.519531 11.9492 0.273438 11.6758C0 11.4297 0 11.0195 0.273438 10.7734L5.05859 5.98828L0.273438 1.17578C0 0.929688 0 0.519531 0.273438 0.273438C0.519531 0 0.929688 0 1.17578 0.273438L6.45312 5.49609Z",
		fill: "#38539A"
	})]
});
const ForwardRef = forwardRef(SvgIconForward);
export { ForwardRef as ReactComponent };
